<template>
  <el-card>
    <el-form :inline="true" @submit.prevent>
      <el-form-item label="模块">
        <el-input v-model.trim="query.module" placeholder="ticket/subscription" style="width: 180px" />
      </el-form-item>
      <el-form-item label="动作">
        <el-input v-model.trim="query.action" placeholder="create/assign/resolve" style="width: 200px" />
      </el-form-item>
      <el-form-item label="操作人">
        <el-input v-model.trim="query.operator_id" placeholder="admin_id" style="width: 140px" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="load">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" stripe border v-loading="loading" size="small">
      <el-table-column prop="id" label="ID" width="90" />
      <el-table-column prop="operator_id" label="操作人" width="90" />
      <el-table-column prop="module" label="模块" width="120" />
      <el-table-column prop="action" label="动作" width="120" />
      <el-table-column prop="target_id" label="目标ID" min-width="120" />
      <el-table-column prop="ip" label="IP" min-width="120" />
      <el-table-column prop="created_at" label="时间" min-width="160" />
      <el-table-column label="变更前" min-width="220" show-overflow-tooltip>
        <template #default="{ row }">{{ row.before_json || '-' }}</template>
      </el-table-column>
      <el-table-column label="变更后" min-width="220" show-overflow-tooltip>
        <template #default="{ row }">{{ row.after_json || '-' }}</template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { adminApi } from '../api/admin'

const loading = ref(false)
const list = ref([])
const query = reactive({ module: '', action: '', operator_id: '' })

async function load() {
  loading.value = true
  try {
    const data = await adminApi.auditLogs({
      page: 1,
      page_size: 50,
      module: query.module || undefined,
      action: query.action || undefined,
      operator_id: query.operator_id || undefined
    })
    list.value = data.list || []
  } catch (e) {
    ElMessage.error(e.message || '加载审计日志失败')
  } finally {
    loading.value = false
  }
}

onMounted(load)
</script>
